import React from 'react';
import BoxWithLinearProgress from 'components/BoxWithLinearProgress';

const LinerLoadingPage = () => {
    return <BoxWithLinearProgress isLinearProgress={true} />;
};

export default LinerLoadingPage;
